
<template>
    <div>
        <div class="information_input">
            <div class="information_Title">标题</div>
            <div class="input_el" style="width:85%">
                <div style="padding: 0px 0 10px 0;">
                    <span>A段： &nbsp;</span>
                    <el-input
                        class="width97 active"
                        type="textarea"
                        placeholder="标题长度不超过200个字符"
                        v-model="inTitle1"
                        maxlength="200"
                        autosize
                        show-word-limit
                        @change="titleChange1"
                    ></el-input>
                    <i
                        style="color: #020afb;font-size: 22px;"
                        class="icon--zitidaxiao iconfont"
                        slot="suffix"
                        @click="handleIconClick1"
                    ></i>
                </div>
                <div style="padding: 0px 0 10px 0;">
                    <span>B段： &nbsp;</span>
                    <el-input
                        class="width97"
                        type="textarea"
                        placeholder="标题长度不超过200个字符"
                        v-model="inTitle2"
                        maxlength="200"
                        autosize
                        show-word-limit
                        @change="titleChange2"
                    ></el-input>
                    <i
                        style="color: #020afb;font-size: 22px;"
                        class="icon--zitidaxiao iconfont"
                        slot="suffix"
                        @click="handleIconClick2"
                    ></i>
                </div>
                <div style="padding: 0px 0 10px 0;">
                    <span>C段： &nbsp;</span>
                    <el-input
                        class="width97"
                        type="textarea"
                        placeholder="标题长度不超过200个字符"
                        v-model="inTitle3"
                        maxlength="200"
                        autosize
                        show-word-limit
                        @change="titleChange3"
                    ></el-input>
                    <i
                        style="color: #020afb;font-size: 22px;"
                        class="icon--zitidaxiao iconfont"
                        slot="suffix"
                        @click="handleIconClick3"
                    ></i>
                </div>
                <div>
                    <span>D段： &nbsp;</span>
                    <el-input
                        class="width97"
                        type="textarea"
                        placeholder="标题长度不超过200个字符"
                        v-model="inTitle4"
                        maxlength="200"
                        autosize
                        show-word-limit
                        @change="titleChange4"
                    ></el-input>
                    <i
                        style="color: #020afb;font-size: 22px;"
                        class="icon--zitidaxiao iconfont"
                        slot="suffix"
                        @click="handleIconClick4"
                    ></i>
                </div>
            </div>
            <div style="float: right;">
                <el-button type="primary" @click="addTitle">生成标题</el-button>
            </div>
        </div>
        <div class="information_tips">标题注意 ：(多个值用双逗号隔开比如:[a,,b,,c])</div>
        <div class="titlelist" v-show="generateTitle">
            <div class="Minister-top-top informationbackground">
                <div
                    class="Minister-top-right Minister-top-color"
                    @click="contentClick"
                >{{variantcontent}}</div>
            </div>
            <el-table
                v-show="varianttypt"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%;padding: 0 0 0 10px;"
                @selection-change="titleChange"
            >
                <el-table-column type="selection" width="30"></el-table-column>
                <el-table-column label="全部" width="50"></el-table-column>
                <el-table-column label="生成的标题">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.name" @change="dataChange" style="width:80%"></el-input>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="标题的相似度" width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.val}}%</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: "eTitle",
    data() {
        return {
            // 标题
            variantcontent: "收起",
            varianttypt: true,
            generateTitle: false,
            inTitle1: "", //标题1
            inTitle2: "", //标题2
            inTitle3: "", //标题3
            inTitle4: "", //标题4
            tableData: [], //标题
            flag: false
        };
    },
    mounted() {
        // this.handleIconClick1();
    },
    created() {},
    methods: {
        handleIconClick1() {
            this.inTitle1 = this.handleIconClick(this.inTitle1);
        },
        handleIconClick2() {
            this.inTitle2 = this.handleIconClick(this.inTitle2);
        },
        handleIconClick3() {
            this.inTitle3 = this.handleIconClick(this.inTitle3);
        },
        handleIconClick4() {
            this.inTitle4 = this.handleIconClick(this.inTitle4);
        },
        titleChange1() {
            this.inTitle1 = this.Capitalization(this.inTitle1);
        },
        titleChange2() {
            this.inTitle2 = this.Capitalization(this.inTitle2);
        },
        titleChange3() {
            this.inTitle3 = this.Capitalization(this.inTitle3);
        },
        titleChange4() {
            this.inTitle4 = this.Capitalization(this.inTitle4);
        },
        // 首字母大写
        Capitalization(title){
            const chineseEnglish = title.replace(/，，/gi, ",,");
            const array = chineseEnglish.split(/,/);
            const arr1 = [];
            array.forEach(ele => {
                const str = ele.split(/\s+/);
                arr1.push(str);
            });
            for (let i = 0; i < arr1.length; i++) {
                for (let j = 0; j < arr1[i].length; j++) {
                    if (arr1[i][j]) {
                        arr1[i][j] = arr1[i][j][0].toUpperCase() + arr1[i][j].substr(1);
                    }
                }
            }
            let str = "";
            arr1.forEach((item, index) => {
                const str1 = item.join(" ");
                if (index != 0) {
                    str += `,${str1}`;
                } else {
                    str = str1;
                }
            });
            return str;
        },
        // 首字母大小写
        handleIconClick(title) {
            this.flag = !this.flag;
            const array = title.split(/,/);
            const arr1 = [];
            array.forEach(ele => {
                const str = ele.split(/\s+/);
                arr1.push(str);
            });
            for (let i = 0; i < arr1.length; i++) {
                for (let j = 0; j < arr1[i].length; j++) {
                    if (arr1[i][j] && this.flag) {
                        arr1[i][j] =
                            arr1[i][j][0].toUpperCase() + arr1[i][j].substr(1);
                    } else if (arr1[i][j]) {
                        arr1[i][j] =
                            arr1[i][j][0].toLowerCase() + arr1[i][j].substr(1);
                    }
                }
            }
            let str = "";
            arr1.forEach((item, index) => {
                const str1 = item.join(" ");
                if (index != 0) {
                    str += `,${str1}`;
                } else {
                    str = str1;
                }
            });
            return str;
        },
        // 生成标题
        addTitle() {
            let inTitle1 = this.inTitle1.split(",,");
            let inTitle2 = this.inTitle2.split(",,");
            let inTitle3 = this.inTitle3.split(",,");
            let inTitle4 = this.inTitle4.split(",,");
            console.log(inTitle1);
            if (
                this.inTitle1 == "" ||
                this.inTitle2 == "" ||
                this.inTitle3 == "" ||
                this.inTitle4 == ""
            ) {
                this.$message.error("标题不能为空");
            } else {
                inTitle1.forEach(element => {
                    inTitle2.forEach(item => {
                        inTitle3.forEach(val => {
                            inTitle4.forEach(ele => {
                                console.log(element);
                                var param = {
                                    name: `${element} ${item} ${val} ${ele}`,
                                    val: 0
                                };
                                this.tableData.push(param);
                            });
                        });
                    });
                });
            }
            this.titleSimilarity(); // 设置名称相似度
        },
        titleSimilarity() {
            let str = "";
            this.tableData.forEach((item, index) => {
                if (index == 0) {
                    item.val = 100;
                    str = this.tableData[0].name;
                } else {
                    const arr = item.name.split(" ");
                    arr.forEach(ele => {
                        if (str.includes(ele)) {
                            item.val += 25;
                        }
                    });
                }
            });
            this.setSort(); //从小到大的排序
            this.generateTitle = true;
            this.toggleSelection(); // 设置全选
        },
        setSort() {
            const arr = this.tableData;
            var min;
            var arrname;
            for (let i = 1; i < arr.length; i++) {
                for (var j = i; j < arr.length; j++) {
                    if (arr[i].val > arr[j].val) {
                        min = arr[j].val;
                        arr[j].val = arr[i].val;
                        arr[i].val = min;

                        arrname = arr[j].name;
                        arr[j].name = arr[i].name;
                        arr[i].name = arrname;
                    }
                }
            }
        },
        toggleSelection() {
            this.tableData.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
        },
        // 标题选中按钮
        titleChange(val) {
            //  console.log(val)
        },
        // 标题展开
        contentClick() {
            this.varianttypt = !this.varianttypt;
            if (this.variantcontent === "展开") {
                this.variantcontent = "收起";
            } else {
                this.variantcontent = "展开";
            }
        },
        // 标题列表修改
        dataChange(val) {
            console.log(val);
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .width97 .el-textarea__inner:focus{
        outline: 0;
        border-color: #cce198;
    }
}
</style>